import React from "react";
import "../styles/landingpage.css";
import { getBannerImage } from "../utils/CommonFunction";

type Props = {
  otp: {
    one: string;
    two: string;
    three: string;
    four: string;
  };
  handleChangeOTP: (e: any, index: any) => void;
  handleBackspace: (
    e: React.KeyboardEvent<HTMLInputElement>,
    index: number
  ) => void;
  onResendOtpPressed: () => void;
  inputRef: React.RefObject<HTMLInputElement>[];
  showLoader: boolean;
  errorMsg: string;
  showError: boolean;
  onVerifyPressed: () => void;
  phoneNo: string;
  handlePhoneNoChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  seconds: number;
  isHidden: boolean;
  isChecked: boolean;
  handleOverLay: () => void;
  handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onPressCheckBox: () => void;
  paymentMethod: string;
  handleNavigation: () => void;
  parameter: string 
  utm_campaign: string
};

// const bannerImages: { [key: string]: string } = {
//   ac: "https://cdn.econceptionscdn.com/Tamasha/imgs/Frame 1171276166.png",
//   bike: "https://cdn.econceptionscdn.com/Tamasha/imgs/Artwork.png",
//   cricket: "https://cdn.econceptionscdn.com/Tamasha/imgs/asiacupcrik.webp",
//   wcl: "https://cdn.econceptionscdn.com/Tamasha/imgs/wcl-generic-artwork.webp",
//   asiacup: "https://cdn.econceptionscdn.com/Tamasha/imgs/asiacup.webp",
//   epl: "https://cdn.econceptionscdn.com/Tamasha/imgs/epl.webp",
//   epl2: "https://cdn.econceptionscdn.com/Tamasha/imgs/epl2.webp",
//   trin: "https://cdn.econceptionscdn.com/Tamasha/imgs/tri-series-landing.webp",
//   food: "https://cdn.econceptionscdn.com/Tamasha/imgs/Tamasha-Food.webp",
// };

export const Landingmfs = (props: Props) => {
 const selectedImg = getBannerImage(
    props.utm_campaign,
    props.parameter
  );
  return (
    <div className="">
      <div className="dm-section">
        <div className="main-content">
          <img
            src={selectedImg}
            alt="sports"
            width={345}
            height={333}
            className="lp-main-image"
            {...{ fetchpriority: "high" }}
          />

          <div className="lp-absolute-content">
            {props.paymentMethod === "" && (
              <p className="landingtext">Please select your payment method.</p>
            )}
            <div className="numberdiv">
              {" "}
              <div className="check_methods">
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="paymentMethod"
                    id="jazzCashRadio"
                    value="jazzcash"
                    onChange={props.handleChange}
                  />
                  <label className="form-check-label" htmlFor="jazzCashRadio">
                    <img
                      src="https://cdn.econceptionscdn.com/Tamasha/imgs/JC-logo.webp"
                      alt="jazzcash-img"
                      width={75}
                      height={75}
                      loading="lazy"
                    />
                  </label>
                </div>

                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="paymentMethod"
                    id="easyPaisaRadio"
                    value="easypaisa"
                    onChange={props.handleChange}
                  />
                  <label className="form-check-label" htmlFor="easyPaisaRadio">
                    <img
                      src="https://cdn.econceptionscdn.com/Tamasha/imgs/EP-logo.webp"
                      alt="easypaisa-img"
                      width={75}
                      height={75}
                      loading="lazy"
                    />
                  </label>
                </div>
              </div>
              {/* <p className="landingtext">Please enter your number</p>
               */}
              <p className="landingtext">
                {props.paymentMethod === ""
                  ? "Please enter your number"
                  : `Please enter your ${
                      props.paymentMethod === "jazzcash"
                        ? "JazzCash"
                        : props.paymentMethod === "easypaisa"
                        ? "easypaisa"
                        : ""
                    } number`}
              </p>
              <div className="input-wraper">
                <span>+92</span>
                <input
                  type="number"
                  placeholder="3XX - XXXXXXX"
                  className="numberinput"
                  max={10}
                  value={props.phoneNo}
                  onChange={(e) => {
                    props.handlePhoneNoChange(e);
                  }}
                />
              </div>
            </div>

            {/* otp div */}
            {props.showError && <p className="error">{props.errorMsg}</p>}

            <div className="otpDiv">
              {props.phoneNo.length === 10 &&
              props.paymentMethod === "easypaisa" ? (
                <>
                  <p className="landingtext">
                    Please enter the OTP received via SMS.
                  </p>
                  <div className="otpinputWraper">
                    <input
                      type="tel"
                      name="one"
                      maxLength={1}
                      autoFocus
                      value={props.otp.one}
                      onChange={(e) => {
                        props.handleChangeOTP(e, 0);
                      }}
                      ref={props.inputRef[0]}
                      onKeyDown={(e) => {
                        props.handleBackspace(e, 0);
                      }}
                    />
                    <input
                      type="tel"
                      name="two"
                      maxLength={1}
                      value={props.otp.two}
                      onChange={(e) => {
                        props.handleChangeOTP(e, 1);
                      }}
                      ref={props.inputRef[1]}
                      onKeyDown={(e) => {
                        props.handleBackspace(e, 1);
                      }}
                    />
                    <input
                      type="tel"
                      name="three"
                      maxLength={1}
                      value={props.otp.three}
                      onChange={(e) => {
                        props.handleChangeOTP(e, 2);
                      }}
                      ref={props.inputRef[2]}
                      onKeyDown={(e) => {
                        props.handleBackspace(e, 2);
                      }}
                    />
                    <input
                      type="tel"
                      name="four"
                      maxLength={1}
                      value={props.otp.four}
                      onChange={(e) => {
                        props.handleChangeOTP(e, 3);
                      }}
                      ref={props.inputRef[3]}
                      onKeyDown={(e) => {
                        props.handleBackspace(e, 3);
                      }}
                    />
                  </div>

                  {/* <div className="invalidotp">Invalid OTP entered</div> */}

                  <div className="otpcounter">
                    <p>
                      {props.seconds === 0 ? (
                        <a
                          style={{ cursor: "pointer" }}
                          onClick={props.onResendOtpPressed}
                        >
                          Resend Otp
                        </a>
                      ) : null}
                      {props.seconds > 0 && (
                        <>
                          <>Resend 00:{props.seconds}</>
                          {props.seconds === 0 && (
                            <a
                              style={{ cursor: "pointer" }}
                              onClick={props.onResendOtpPressed}
                            >
                              Resend Otp
                            </a>
                          )}
                        </>
                      )}
                    </p>
                  </div>
                  {props.showLoader ? (
                    <div className="subscribe-btn">
                      <button>Loading...</button>
                    </div>
                  ) : (
                    <div className="subscribe-btn btn_bg_blue">
                      <button onClick={props.onVerifyPressed}>
                        Subscribe Now
                      </button>
                    </div>
                  )}
                </>
              ) : null}
            </div>
            {props.paymentMethod === "jazzcash" &&
              props.phoneNo.length === 10 && (
                <div className="subscribe-btn btn_bg_blue">
                  <button onClick={props.handleNavigation}>
                    Subscribe Now
                  </button>
                </div>
              )}

            <div className="policytext">
              <div className="checkflex">
                <input
                  type="checkbox"
                  checked={props.isChecked}
                  onChange={props.onPressCheckBox}
                />
                <p>
                  By signing in, you agree to the{" "}
                  <a href="https://tamashaweb.com/terms-of-use" target="_blank">
                    {" "}
                    Terms of Use
                  </a>{" "}
                  and
                  <a href="/privacy-policy" target="_blank">
                    {" "}
                    Privacy Policy.
                  </a>
                </p>
              </div>

              {/* {props.package_id === "1" ? ( */}
              <p style={{ fontStyle: "Italic", marginTop: "10px" }}>
                * Continue click krne se aap ke account se Rs. 1 kat jayega. Yeh
                offer 24 hours ke liye valid hai jis ke baad automatically Rs.
                360/month inc. tax deduct honge.
              </p>
              {/* ) : (
                <> */}
              {/* {props.package_id === "2" ? (
                    <p>Rs. 120/week for Prepaid & Rs. 360/mon for Postpaid</p>
                  ) : (
                    <>
                      {props.package_id === "3" ? (
                        <p>Rs. 360/month for Prepaid & Postpaid</p>
                      ) : (
                        <p>Rs. 10 day for Prepaid & Rs. 360/mon for Postpaid</p>
                      )}
                    </>
                  )}
                </>
              )} */}
            </div>
          </div>
          <div
            className={`cong-overlay ${props.isHidden ? "hidden" : ""}`}
            onClick={props.handleOverLay}
          ></div>
          <div className={`cong-box ${props.isHidden ? "hidden" : ""}`}>
            <img
              src="https://cdn.econceptionscdn.com/Tamasha/imgs/yellowstar.webp"
              alt="star"
            />
            <div className="mubarakhead">Mubarak Ho!</div>
            <div className="mubaraltext">
              Aap Kamyabi k sath Tamasha Family Ka hisa ban chukay hain,
              <br /> Abhi Tamasha app download karein!
            </div>
            <div className="tamashastore">
              <a href="https://app.tamashaweb.com/JHLA" target="_blank">
                <img
                  src="https://cdn.econceptionscdn.com/Tamasha/imgs/appstore.webp"
                  alt="app store"
                />
              </a>
              <a href="https://app.tamashaweb.com/JHLA" target="_blank">
                <img
                  src="https://cdn.econceptionscdn.com/Tamasha/imgs/google_play.webp"
                  alt="google play"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Landingmfs;
